export default __webpack_public_path__ + "c470fc1bffd57f84662432d624540b63.png";